import { yupResolver } from '@hookform/resolvers/yup';
import { Grid, Stack, DialogContent } from '@mui/material';
import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { addRoleForWorkspace } from 'wisestep-api';
import {
  ControlledTextInput,
  WsButton,
  WsDialog,
  WsTypography,
  WsTypoVariants,
  WsSelect,
  WsSelectObj,
} from 'wisestep-base';
import { object, string } from 'yup';

import { warning, success } from '../../utils/NotificationMessages';
import { useNotificationStore } from '../../utils/NotificationStore';
export const defaultRoles: WsSelectObj[] = [
  {
    label: 'Account Manager',
    value: 'Account Manager',
  },
  {
    label: 'User',
    value: 'User',
  },
  {
    label: 'Lead',
    value: 'Lead',
  },
  {
    label: 'Head',
    value: 'Head',
  },
  {
    label: 'Admin',
    value: 'Admin',
  },
  {
    label: 'Analyst',
    value: 'Analyst',
  },
];

const AddRoleAccessControl = () => {
  const setNotification = useNotificationStore((state) => state.setNotification);
  const [openModal, setOpenModal] = useState(false);

  const addRoleWorkspace = async () => {
    try {
      const payload = {
        roleName: methods.getValues('role'),
        rolePreference: methods.getValues('rolePreference'),
      };
      const response = await addRoleForWorkspace(payload);
      if (response.data) {
        setNotification(success('Roles has been added Successfully'));
        openCloseModal(false);
      }
    } catch (error) {
      setNotification(warning('Something Went Wrong , Please try again'));
    }
  };

  const openCloseModal = (value: boolean) => {
    methods.setValue('role', '');
    methods.setValue('rolePreference', '');
    setOpenModal(value);
  };

  const validationSchema = object().shape({
    role: string().required('Role is required'),
  });

  const methods = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      role: '',
      rolePreference: '',
    },
  });

  return (
    <FormProvider {...methods}>
      <Stack>
        <WsButton variant="contained" size="large" onClick={() => openCloseModal(true)}>
          Add New Role
        </WsButton>
      </Stack>

      <WsDialog size="medium" openDialog={openModal}>
        <DialogContent sx={{ p: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} mt={2}>
              <Stack direction="column">
                <WsTypography variant={WsTypoVariants.SUB_TITLE}>Role Name</WsTypography>
              </Stack>
              <ControlledTextInput
                name="role"
                type="text"
                fullWidth
                id="role"
                variant="outlined"
                autoComplete="marginTop"
              />
            </Grid>
            <Grid item xs={12} mt={2}>
              <Stack direction="column">
                <WsTypography variant={WsTypoVariants.SUB_TITLE}>Role Preference</WsTypography>
              </Stack>
              <WsSelect name="rolePreference" selectArray={defaultRoles} />
            </Grid>
            <Grid item xs={12} spacing={2}>
              <Stack direction="row" justifyContent="flex-end" spacing={2}>
                <WsButton variant="outlined" size="large" onClick={() => openCloseModal(false)}>
                  Cancel
                </WsButton>
                <WsButton type="submit" size="large" onClick={() => addRoleWorkspace()}>
                  Save
                </WsButton>
              </Stack>
            </Grid>
          </Grid>
        </DialogContent>
      </WsDialog>
    </FormProvider>
  );
};

export default AddRoleAccessControl;
